const replaceDotToComma = (number) => {
  const numberString = `${number}`;
  return numberString.replace(/\./g, ',');
};

const getToFixed = (num) => {
  return (num / 1000).toFixed(1).replace(/\.0$/, '');
};

const getNumberAsString = (min, max) => {
  let minNum, maxNum;

  if (min >= 1000) {
    minNum = getToFixed(min);
  } else minNum = min;

  if (max >= 1000) {
    maxNum = getToFixed(max) + 'K';
  } else maxNum = max;

  return String(`€${replaceDotToComma(minNum)}–${replaceDotToComma(maxNum)}`);
};

const combineValues = (min, max) => {
  if (min === max) return max;
  return `${min}-${max}`;
};

const getWorkingWeek = (days) => {
  return (days / 5).toFixed(0);
};

const combineDays = (min, max) => {
  const minDays = min - 5;
  const maxDays = max - 7;
  if (minDays === maxDays) return `${maxDays} days`;
  return `${minDays}-${maxDays} days`;
};

export { getNumberAsString, combineValues, getWorkingWeek, combineDays };
